import { render, staticRenderFns } from "./UpdateTenantPopUp.vue?vue&type=template&id=ccebc4ac&scoped=true"
import script from "./UpdateTenantPopUp.vue?vue&type=script&lang=js"
export * from "./UpdateTenantPopUp.vue?vue&type=script&lang=js"
import style0 from "./UpdateTenantPopUp.vue?vue&type=style&index=0&id=ccebc4ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ccebc4ac",
  null
  
)

export default component.exports